import SupplyLocationIDSelector from '@/views/components/Selectors/SupplyLocationIDSelector';
import SupplyRegionsSelector from '@/views/components/Selectors/SupplyRegionsSelector';
import SupplyRscmSelector from '@/views/components/Selectors/SupplyRscmSelector';
import TrailerStoreIdSelector from '@/views/components/Selectors/TrailerStoreIdSelector';
import { Col, Form, Row } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveSupplyZone } from '../../../redux/Savers/SaversEffects';
import { setAppLoader } from '../../../redux/common/CommonActions';
import PrimaryLabel from '../../components/Labels/PrimaryLabel';
import AlertModal from '../../components/Modals/AlertModal';
import Drawer from '../../components/Modals/Drawer';

const LocationSearch = ({ onSearchClick, locationNames, IdOptions, supplyZoneNumberOptions, isModal }) => {
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const [hidden, setHidden] = useState(false);
  const [selectedSupplyZoneId, setSelectedSupplyZoneId] = useState('');
  const [selectedSupplyZoneName, setSelectedSupplyZoneName] = useState('');
  const [selectedSupplyZoneRegionName, setSelectedZoneRegionName] = useState('');
  const [selectedSupplyZoneNumber, setSelectedSupplyZoneNumber] = useState('');
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [selectedValues, setSelectedValues] = useState({
    selectedLocationId: '',
    selectedRegionId: '',
    selectedRscmId: '',
  });
  const { selectedLocationId, selectedRegionId, selectedRscmId } = selectedValues;

  const handleSelectedValues = (field, value) => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const closeModal = () => {
    form.resetFields();
    setHidden(false);
  };

  const OpenSZPopup = () => {
    setHidden(true);
  };

  const handleSave = () => {
    dispatch(setAppLoader(true));

    const data = [
      {
        branchKey: selectedLocationId,
        rscmUserId: selectedRscmId,
        regionKey: selectedRegionId,
      },
    ];

    saveSupplyZone(data)
      .then(() => {
        dispatch(setAppLoader(false));
        setAlertMessage('Saved successfully');
        setAlertOpen(true);
        form.resetFields();
        setHidden(false);
        onSearchClick(
          selectedSupplyZoneId,
          selectedSupplyZoneName,
          selectedSupplyZoneRegionName,
          selectedSupplyZoneNumber,
        );
      })
      .catch((error) => {
        console.error('Save failed:', error);
        dispatch(setAppLoader(false));
      });
  };

  const handleAlertOk = () => {
    setAlertOpen(false);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const onSupplyZoneIdSelect = (e) => {
    if (e !== undefined) {
      setSelectedSupplyZoneId(e.value);
      onSearchClick(e.value, selectedSupplyZoneName, selectedSupplyZoneRegionName, selectedSupplyZoneNumber);
    } else {
      setSelectedSupplyZoneId('');
      onSearchClick('', selectedSupplyZoneName, selectedSupplyZoneRegionName, selectedSupplyZoneNumber);
    }
  };

  const onSupplyZoneNameSelect = (e) => {
    if (e !== undefined) {
      setSelectedSupplyZoneName(e.label);
      onSearchClick(selectedSupplyZoneId, e.label, selectedSupplyZoneRegionName, selectedSupplyZoneNumber);
    } else {
      setSelectedSupplyZoneName('');
      onSearchClick(selectedSupplyZoneId, '', selectedSupplyZoneRegionName, selectedSupplyZoneNumber);
    }
  };

  const onSupplyZoneRegionSelect = (e) => {
    if (e !== undefined) {
      setSelectedZoneRegionName(e.label);
      onSearchClick(selectedSupplyZoneId, selectedSupplyZoneName, e.label, selectedSupplyZoneNumber);
    } else {
      setSelectedZoneRegionName('');
      onSearchClick(selectedSupplyZoneId, selectedSupplyZoneName, '', selectedSupplyZoneNumber);
    }
  };

  const onSupplyZoneNumberSelect = (e) => {
    if (e !== undefined) {
      setSelectedSupplyZoneNumber(e.label);
      onSearchClick(selectedSupplyZoneId, selectedSupplyZoneName, selectedSupplyZoneRegionName, e.label);
    } else {
      setSelectedSupplyZoneNumber('');
      onSearchClick(selectedSupplyZoneId, selectedSupplyZoneName, selectedSupplyZoneRegionName, '');
    }
  };

  return (
    <>
      <Drawer
        width="40%"
        visible={hidden}
        headerContents={<PrimaryLabel className="text-white">CT Location Management page</PrimaryLabel>}
        onClose={closeModal}
      >
        <AlertModal
          title="Alert"
          open={alertOpen}
          description={alertMessage}
          onOk={handleAlertOk}
          onClose={handleAlertClose}
        />

        <div className="popup-body p-10">
          <Form form={form}>
            <Row gutter={20}>
              <Col sm={12}>
                <SupplyLocationIDSelector
                  label="New Location ID"
                  editMode
                  name="SZID2"
                  value={selectedLocationId}
                  margin="m-0"
                  placeholder="Location ID #"
                  onChange={(e) => handleSelectedValues('selectedLocationId', e)}
                />
              </Col>

              <Col sm={12}>
                <SupplyRscmSelector
                  label="RSCM"
                  editMode
                  name="rscm"
                  margin="m-0"
                  placeholder="RSCM"
                  onChange={(e) => handleSelectedValues('selectedRscmId', e)}
                />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12}>
                <SupplyRegionsSelector
                  label="Region"
                  editMode
                  name="region"
                  margin="m-0"
                  placeholder="Region"
                  onChange={(e) => handleSelectedValues('selectedRegionId', e)}
                />
              </Col>

              <Col sm={12} className="text-center mt-25">
                <button type="button" className="btn btn-dipblue" onClick={handleSave}>
                  {' '}
                  Submit{' '}
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Drawer>

      <Row gutter={20}>
        {!isModal && (
          <Col className="mt-25">
            <button type="button" className="btn btn-dipblue" onClick={OpenSZPopup}>
              {' '}
              Update Location{' '}
            </button>
          </Col>
        )}

        <Col flex={1}>
          <Row gutter={20}>
            <Col sm={6}>
              <TrailerStoreIdSelector
                label="Filter by Location # / Location ID"
                editMode
                name="locationId"
                placeholder="Location #"
                onChange={onSupplyZoneIdSelect}
                options={IdOptions}
              />
            </Col>

            <Col sm={6}>
              <TrailerStoreIdSelector
                label="Filter by Location Name"
                editMode
                name="locationName"
                placeholder="Location Name"
                onChange={onSupplyZoneNameSelect}
                isIDSelector={false}
                options={locationNames}
              />
            </Col>

            <Col sm={6}>
              <TrailerStoreIdSelector
                label="Filter by Supply Zone Number"
                editMode
                name="SzNumber"
                placeholder="SupplyZone Number"
                onChange={onSupplyZoneNumberSelect}
                isIDSelector={false}
                options={supplyZoneNumberOptions}
              />
            </Col>

            <Col sm={6}>
              <SupplyRegionsSelector
                label="Filter by Location region name"
                editMode
                name="RegionName"
                margin="m-0"
                placeholder="Region Name"
                onChange={onSupplyZoneRegionSelect}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default LocationSearch;
